module.exports = __webpack_public_path__ + "ed08dc37f4956d42a276fdfc11e00dc1.jpg";